<div class="control-handle" [class.selected]="selected" *ngIf="!galleryMode">
    <div *ngIf="controlHandleBtn" class="handle-btn" data-testid="control-handle-btn">
        <ng-content></ng-content>
        <i class="sp-icon icon-drag-drop"> </i>
    </div>

    <div class="control-handle-container">
        <div class="control-handle-content">
            <div
                *ngIf="controlHandleCheckbox"
                [class.disabled]="controlHandleDisableCheckbox"
                class="control-handle-checkbox"
            >
                <input
                    type="checkbox"
                    [checked]="controlHandleCheckboxChecked"
                    (click)="toggleCheckBoxEvent.emit(!controlHandleCheckboxChecked)"
                />
            </div>
            <div *ngIf="controlHandleIcon" class="control-handle-icon" data-testid="control-handle-icon">
                <img [src]="controlHandleIcon" alt="handler" />
            </div>
            <div
                *ngIf="hasImagePreview"
                class="control-handle-image-preview"
                data-testid="control-handle-image-preview"
            >
                <img class="preview-placeholder" [src]="imagePreviewSrc" alt="" (error)="showNextImagePreview()" />
            </div>
            <div
                class="control-handle-text"
                [class.control-width-sm]="hasImagePreview"
                [class.control-width-md]="controlHandleIcon || controlHandleCheckbox"
                [class.control-width-lg]="!controlHandleCheckbox && !controlHandleIcon && !hasImagePreview"
                [class.with-1-btn]="eventsCount === 1"
                [class.with-2-btn]="eventsCount === 2"
            >
                <span *ngIf="controlHandleMainText" class="main-text strip-text" data-testid="main-text">
                    {{ controlHandleMainText }}
                </span>
                <span
                    *ngIf="controlHandleSubText"
                    class="small strip-text"
                    [class.text-danger]="controlHandleSubTextDanger"
                    [class.text-warning]="controlHandleSubTextWarning"
                    [class.text-muted]="!controlHandleSubTextDanger && !controlHandleSubTextWarning"
                    data-testid="sub-text"
                >
                    {{ controlHandleSubText }}
                </span>

                <ng-container *ngIf="variablesTemplate" [ngTemplateOutlet]="variablesTemplate"></ng-container>
            </div>
        </div>

        <div class="control-handle-buttons">
            <div [tooltip]="getDisabledTooltip | translate">
                <button
                    *ngIf="imageEditEvent.observed && !isHasEventInDropdownActionList(controlHandleEvents.imageEdit)"
                    class="btn btn-link"
                    (click)="imageEditEvent.emit()"
                    [class.disabled]="isDisableEditor"
                >
                    <span class="sp-icon icon-crop-pic"> </span>
                </button>
            </div>
            <button
                *ngIf="replaceActionEvent.observed && !isHasEventInDropdownActionList(controlHandleEvents.replace)"
                class="btn btn-link"
                (click)="replaceActionEvent.emit()"
            >
                <span class="sp-icon icon-marquee-upload"> </span>
            </button>
            <button
                *ngIf="editActionEvent.observed && !isHasEventInDropdownActionList(controlHandleEvents.edit)"
                class="btn btn-link"
                (click)="editActionEvent.emit()"
            >
                <span class="sp-icon icon-ap-edit"> </span>
            </button>
            <button
                *ngIf="settingActionEvent.observed && !isHasEventInDropdownActionList(controlHandleEvents.setting)"
                class="btn btn-link"
                (click)="settingActionEvent.emit()"
            >
                <span class="sp-icon icon-settings"> </span>
            </button>
            <button
                *ngIf="catalogActionEvent.observed && !isHasEventInDropdownActionList(controlHandleEvents.catalog)"
                class="btn btn-link"
                (click)="catalogActionEvent.emit()"
            >
                <span class="sp-icon icon-swap"> </span>
            </button>
            <button
                *ngIf="removeActionEvent.observed && !isHasEventInDropdownActionList(controlHandleEvents.delete)"
                class="btn btn-link"
                [class.noHover]="controlHandleDisableDelete"
                [tooltip]="controlHandleDisableDeleteTooltip"
                (click)="removeAction()"
            >
                <span [class.disabled]="controlHandleDisableDelete" class="sp-icon icon-bin color-danger"> </span>
            </button>

            <div *ngIf="controlHandleDropdownActionList?.length" class="p-relative" dropdown>
                <button
                    type="button"
                    class="btn btn-link dropdown-toggle"
                    dropdownToggle
                    aria-haspopup="true"
                    aria-expanded="false"
                >
                    <span class="sp-icon icon-option-horizontal"> </span>
                </button>
                <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
                    <li *ngFor="let item of controlHandleDropdownActionList">
                        <a
                            *ngIf="item === controlHandleEvents.delete"
                            class="dropdown-item"
                            [class.disabled]="controlHandleDisableDelete"
                            [tooltip]="controlHandleDisableDeleteTooltip"
                            (click)="removeAction()"
                        >
                            <span class="sp-icon icon-bin color-danger"> </span>
                            {{ "delete" | translate }}
                        </a>
                        <a
                            *ngIf="item === controlHandleEvents.copy"
                            class="dropdown-item"
                            (click)="copyActionEvent.emit()"
                        >
                            <span class="sp-icon icon-windows"> </span>
                            {{ "duplicate" | translate }}
                        </a>
                        <a
                            *ngIf="item === controlHandleEvents.addSubMenu"
                            class="dropdown-item"
                            (click)="addSubMenuEvent.emit()"
                        >
                            <span class="sp-icon icon-arrow-right1"> </span>
                            {{ "add_submenu_item" | translate }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<div *ngIf="galleryMode" class="gallery-control">
    <img
        *ngIf="hasImagePreview"
        class="gallery-control-image"
        [src]="imagePreviewSrc"
        alt=""
        (error)="showNextImagePreview()"
    />

    <div class="control-handle-buttons" dropdown [container]="'body'">
        <button class="btn btn-link" dropdownToggle>
            <span class="sp-icon icon-option-vertical"></span>
        </button>

        <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
            <li *ngIf="settingActionEvent.observed">
                <a (click)="settingActionEvent.emit()">
                    <span class="sp-icon icon-settings"> </span>
                    {{ "settings" | translate }}
                </a>
            </li>

            <li *ngIf="replaceActionEvent.observed">
                <a (click)="replaceActionEvent.emit('fm')">
                    <span class="sp-icon icon-marquee-upload"> </span>
                    {{ "select_from_file_maanager" | translate }}
                </a>
            </li>

            <li *ngIf="replaceActionEvent.observed">
                <a (click)="replaceActionEvent.emit('stock')">
                    <span class="sp-icon icon-marquee-upload"> </span>
                    {{ "select_stock_images" | translate }}
                </a>
            </li>

            <li
                [tooltip]="getDisabledTooltip | translate"
                [class.disabled]="isDisableEditor"
                *ngIf="imageEditEvent.observed"
            >
                <a (click)="imageEditEvent.emit()">
                    <span class="sp-icon icon-crop-pic"> </span>
                    {{ "edit" | translate }}
                </a>
            </li>
            <li role="separator" class="divider"></li>
            <li
                *ngIf="removeActionEvent.observed"
                [tooltip]="controlHandleDisableDeleteTooltip"
                [container]="'body'"
                [class.disabled]="controlHandleDisableDelete"
            >
                <a (click)="removeAction()">
                    <span class="sp-icon icon-bin color-danger"> </span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>
